import { render, staticRenderFns } from "./prePostulacion.vue?vue&type=template&id=6f728ac9&scoped=true"
import script from "./prePostulacion.vue?vue&type=script&lang=js"
export * from "./prePostulacion.vue?vue&type=script&lang=js"
import style0 from "./prePostulacion.vue?vue&type=style&index=0&id=6f728ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f728ac9",
  null
  
)

export default component.exports